import { createFileRoute } from '@tanstack/react-router'
import EditionAudioTechnicalDescription from 'Edition/components/sections/Layout/EditionAudioTechnicalDescription'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/layout')({
    component: EditionAudioTechnicalDescription,
})
